import {Corpus, Table, Load, Chart, CategoriesManager} from 'voyant';

import {Notebook} from './notebook';
import {Util} from './util';
import {Metadata} from './metadata';

/**
 * @namespace Spyral
 */
const Spyral = {
	Notebook,
	Util,
	Metadata,
	Corpus,
	Table,
	Load,
	Chart,
	CategoriesManager
};

export default Spyral;
